define('services/userService',['require','exports','module','utils'],function(require, exports, module) {
    'use strict';
    var utils = require('utils');
    return {
        /**
         * if the current user is in a role.
         * e.g. inRole('Admin,Callcenter')
         * @param {string} roles
         * @returns {bool} 
         */
        inRole: function (roles) {
            var rolesArray = roles.split(',');
            var user = window.ServerData.user;
            return user != null && user.roles.some(function (r) { return rolesArray.some(function (role) { return role === r; }); });
        },

        /**
         * if the user is authenticated
         * @returns {bool} 
         */
        isLoggedIn: function() {
            return window.ServerData.user != null;
        },

        /**
         * If member has any active linked account
         * @returns {bool} 
         */
        isLinked: function() {
            return utils.tryGetValue(window, 'ServerData.user.status.accounts.ActiveAccounts') > 0;
        }
    };
});
